import { defineMessage } from 'react-intl';

export const stationGroupsMessages = {
  listTitle: defineMessage({
    id: 'admin.stationGroups.listScreen.title',
    defaultMessage: 'Grupos de emisoras',
  }),
  stationsCountHeader: defineMessage({
    id: 'admin.stationGroups.listScreen.stationsCountHeader',
    defaultMessage: '# Emisoras',
  }),
  breadcrumb: defineMessage({
    id: 'admin.stationGroups.breadcrumb',
    defaultMessage: 'Grupos de emisoras',
  }),
  stationsLabel: defineMessage({
    id: 'admin.stationGroups.viewScreen.stations',
    defaultMessage: 'Emisoras',
  }),
  slugLabel: defineMessage({
    id: 'admin.stationGroups.viewScreen.slug',
    defaultMessage: 'Slug',
  }),
  accessTypeLabel: defineMessage({
    id: 'admin.stationGroups.viewScreen.accessType',
    defaultMessage: 'Acceso',
  }),
  noStations: defineMessage({
    id: 'admin.stationGroups.viewScreen.noStations',
    defaultMessage: 'No hay emisoras en este grupo',
  }),
  accessTypeOwned: defineMessage({
    id: 'admin.stationGroups.viewScreen.accessType.owned',
    defaultMessage: 'Propio',
  }),
  accessTypeShared: defineMessage({
    id: 'admin.stationGroups.viewScreen.accessType.shared',
    defaultMessage: 'Compartido',
  }),
};
